/** @param {number} ms */
export function formatMsClock(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
}

/** @param {number} totalSeconds */
export function formatDurationLabel(totalSeconds) {
  if (totalSeconds < 60) return `${totalSeconds}s`;
  if (totalSeconds % 60 === 0) return `${totalSeconds / 60}m`;
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}m ${s}s`;
}
